import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { toast } from 'react-toastify';
import useManageOrder from './useManageOrder';
import useManageWeeklyShip from '../weeklyShip/useManageWeeklyShip';
import CircularProgress from '@mui/material/CircularProgress';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import IconButton from '@mui/material/IconButton';
import { formatDate } from '../../utils/dateUtils';

const ArrivalAccept = () => {

  const handleArrival = async (id) => {
    await actionClick(id, 'ของถึงแล้ว')
    // Add your logic for "ของถึงแล้ว" here
  };
  
  const handleMissingItem = async (id) => {
    await actionClick(id, 'แจ้งหาของ')
  };
  
  const handleNoTracking = async (id) => {
    await actionClick(id, 'ขอหลักฐาน')
  };

  const handleCheckThailand = async (id) => {
    await actionClick(id, 'เช็คที่ไทย');
  };

  const actionClick = async (id, action) => {
    const response = await arrivalAccept({orderId: id, action: action})
    if(response){
      toast.success("Order Accepted");
      // Update the specific order in the rowData
      setRowData(prevRowData => {
        if (action === 'ของถึงแล้ว') {
          // Remove the order with the given id
          return prevRowData.filter(order => order.id !== id);
        } else {
          // Update the specific order's status
          return prevRowData.map(order =>
            order.id === id ? { ...order, isArrivalAccept: action } : order
          );
        }
      });
    }else{
      toast.error("There is something wrong.")
    }
  }

  const IconComponent = (params) => {
    return (
      <div className="flex space-x-2">
        <button
          className="bg-green-600 hover:bg-green-500 text-white px-4 rounded-md"
          onClick={() => handleArrival(params.data.id)}
        >
          ของถึงแล้ว
        </button>
        {(params.data.isArrivalAccept !== 'แจ้งหาของ') && (
          <button
            className="bg-yellow-600 hover:bg-yellow-500 text-white px-4 rounded-md"
            onClick={() => handleMissingItem(params.data.id)}
          >
            แจ้งหาของ
          </button>
        )}
        {(params.data.isArrivalAccept !== 'ขอหลักฐาน') && (
          <button
            className="bg-red-600 hover:bg-red-400 text-white px-4 rounded-md"
            onClick={() => handleNoTracking(params.data.id)}
          >
            ขอหลักฐาน
          </button>
        )}
        {(params.data.isArrivalAccept === 'แจ้งหาของ' || params.data.isArrivalAccept === 'ขอหลักฐาน') && (
          <button
            className="bg-blue-600 hover:bg-blue-400 text-white px-4 rounded-md"
            onClick={() => handleCheckThailand(params.data.id)}
          >
            เช็คที่ไทย
          </button>
        )}
      </div>
    );
  };

  const LinkRenderer = (params) => {
    return (
      <div>
        <a target="_blank" href={params.data.url}>{params.data.url}</a>
      </div>
    )
  }

  const columnDefs = [
    { headerName: 'Order Date', field: 'orderDate', flex: 1 },
    { headerName: 'Contact', field: 'contact', flex: 1 },
    { headerName: 'Smile Name', field: 'smileNameInput', flex: 1 },
    { headerName: 'Tracking', field: 'trackingJp', flex: 1 },
    { headerName: 'Link', field: 'url', flex: 1, cellRenderer: LinkRenderer },
    { headerName: 'สถานะของ', field: 'isArrivalAccept', flex: 1 },
    { field: 'action', cellRenderer: IconComponent, flex: 2 }, // Double the flex value
  ];

  const {orders, isLoading, getArrivalAcceptLists, arrivalAccept} = useManageOrder()
  const [rowData, setRowData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('ยังไม่ดำเนินการ');
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    let data;
    if (selectedStatus === 'All') {
      data = rowData;
    } else if (selectedStatus === 'ยังไม่ดำเนินการ') {
      data = rowData.filter(order => 
        order.isArrivalAccept !== 'แจ้งหาของ' &&
        order.isArrivalAccept !== 'ขอหลักฐาน' &&
        order.isArrivalAccept !== 'เช็คที่ไทย'
      );
    } else {
      data = rowData.filter(order => order.isArrivalAccept === selectedStatus);
    }
    setFilteredData(data);
  }, [rowData, selectedStatus]);
  

  useEffect(() => {
    getArrivalAcceptLists()
  },[])

  useEffect(() => {
    const formattedOrders = orders.map(order => ({
      ...order, // spread the other properties of the order
      orderDate: formatDate(order.orderDate),
      contact : order.CustomerProfile ? order.CustomerProfile.contact : ''
    }));
    setRowData(formattedOrders)
  },[orders])

  const getRowStyle = (params) => {
    const today = new Date();
    const orderDate = new Date(params.data.orderDate);

    if (params.data.shipDateId) {
      return { backgroundColor: '#c3f7c3' };
    } else if (!params.data.shipDateId && (orderDate.getTime() + (5 * 24 * 60 * 60 * 1000)) < today.getTime()) {
      return { backgroundColor: '#fffcd6' };
    } else if (!params.data.shipDateId && (orderDate.getTime() + (12 * 24 * 60 * 60 * 1000)) < today.getTime()) {
      return { backgroundColor: '##f5958e' };
    }
    return null;
  };

  return (
    <div className="ag-theme-alpine mx-auto" style={{ width: '100%' }}>
      <h2>รับของถึงคลัง</h2>
      <div className='flex justify-between items-center'>
        <div className='text-2xl'>
          <label htmlFor="statusSelect" className="mr-2">สถานะของ:</label>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="mb-4 p-2 border border-gray-300 rounded-md"
          >
            <option value="All">All</option>
            <option value="ยังไม่ดำเนินการ">ยังไม่ดำเนินการ</option>
            <option value="แจ้งหาของ">แจ้งหาของ</option>
            <option value="ขอหลักฐาน">ขอหลักฐาน</option>
            <option value="เช็คที่ไทย">เช็คที่ไทย</option>
          </select>
        </div>
        {isLoading && <CircularProgress />} {/* Render spinner when loading */}
      </div>
    <div style={{ height: 300, marginTop: '10px' }}>
      <AgGridReact
        columnDefs={columnDefs}
        rowData={filteredData}
        domLayout='autoHeight'
        defaultColDef={{ resizable: true }}
        enableCellTextSelection={true}
        getRowStyle={getRowStyle}
        pagination={true} // Enable pagination
        paginationPageSize={100} // Set page size
        //paginationAutoPageSize={true} // Auto adjust page size
      />  
    </div>
  </div>
  )
}

export default ArrivalAccept